import React, { useState, useEffect, useContext } from "react";
import Button from 'react-bootstrap/Button';
import DataTable from 'react-data-table-component';
import FilterComponent from "./FilterComponent";
import { pendingVacationRequests, approveVacations, rejectVacations } from "../../services/VacationHistoryService";
import { createEvent } from "../../services/CalendarService";
import { getEmployeeById } from "../../services/EmployeesService";
import Loader from "../common/Loader";
import dayjs from 'dayjs';
import { AuthContext } from '../../context/AuthContext'


const PendingRequestsTable = () => {

    const { accessToken } = useContext(AuthContext);
    const [users, setUsers] = useState([])
    const [pending, setPending] = useState(true);
    const [filterText, setFilterText] = useState('');
	const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

	const filteredItems = users.filter(
		item => item.responsible && item.responsible.toLowerCase().includes(filterText.toLowerCase()),
	);

	const subHeaderComponentMemo = React.useMemo(() => {
		const handleClear = () => {
			if (filterText) {
				setResetPaginationToggle(!resetPaginationToggle);
				setFilterText('');
			}
		};

		return (
			<FilterComponent onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} placeholder="Filtrar por responsable..."/>
		);
	}, [filterText, resetPaginationToggle]);

    const showData = async () => {
        const res = await pendingVacationRequests();
        let data = [];
        let formatStartDate;
        let formatEndDate;
        for (const key in res) {
            let employee = await getEmployeeById(res[key].user_id);
            if (res[key].startDate !== null) {
                formatStartDate = dayjs(res[key].start_date).format("DD/MM/YYYY");
                formatEndDate = dayjs(res[key].end_date).format("DD/MM/YYYY");
            }
            data.push({
                name: employee.name + ' ' + employee.last_name,
                start_date: formatStartDate,
                end_date: formatEndDate,
                status: res[key].status,
                total_days: res[key].total_days,
                vacations_id: res[key].vacations_id,
                responsible: res[key].responsible
            })
        }
        setUsers(data)
    }

    useEffect(() => {
        (async () => {
            const data = await showData();
            if (data) {
                setUsers(data);
            }
            setPending(false)
        })();
    }, [])

    const columns = [
        {
            name: 'Nombre',
            selector: row => row.name
        },
        {
            name: 'Fecha Inicio',
            selector: row => row.start_date
        },
        {
            name: 'Fecha Fin',
            selector: row => row.end_date
        },
        {
            name: 'Status',
            selector: row => row.status
        },
        {
            name: 'Dias',
            selector: row => row.total_days
        },
        {
            name: 'Responsable',
            selector: row => row.responsible
        },
        {
            name: '',
            button: true,
            cell: row => (
                <div>
                    <Button variant="outline-success" onClick={() => {
                        approveVacationsById(row.vacations_id);
                        createCalendarEvent(accessToken, row.name, row.start_date, row.end_date, row.vacations_id);
                    }}>Aprobar</Button>
                </div>
            ),
        },
        {
            name: '',
            button: true,
            cell: row => (
                <div>
                    <Button variant="outline-danger" onClick={() => {
                        rejectVacationsById(row.vacations_id);
                    }}>Cancelar</Button>
                </div>
            ),
        },
    ]

    return (
        <div className="container">
            <div className="row align-items-center my-5">
            <h1 className="font-weight-light">Vacaciones pendientes de aprobar</h1>
                <div className="App table">
                    <DataTable
                        columns={columns}
                        data={filteredItems}
                        striped={true}
                        progressPending={pending}
			            progressComponent={<Loader />}
                        pagination
                        paginationResetDefaultPage={resetPaginationToggle}
                        subHeader
                        subHeaderComponent={subHeaderComponentMemo}
                        persistTableHead
                    />
                </div>
            </div>
        </div>
    );
}

const approveVacationsById = async (id) => {    
    let today = new Date();
    let formData = {
        vacations_id: id,
        approve_date: today.toLocaleString("es-ES", {timeZone: "Europe/Madrid"})
    }
    await approveVacations(JSON.stringify(formData));
    await window.location.reload();
}

const rejectVacationsById = async (id) => {    
    let formData = {
        vacations_id: id
    }
    await rejectVacations(JSON.stringify(formData));
    await window.location.reload();
}

const createCalendarEvent = async (access_token, name, startDate, endDate, vacations_id) => {
    let formData = {
        access_token: access_token,
        user_name: name,
        start_date: startDate,
        end_date: endDate,
        vacations_id: vacations_id
    }
    await createEvent(JSON.stringify(formData));
    await window.location.reload();
}

export default PendingRequestsTable;